/**
 * Deterministic randomness for the tree's scenery. Every picture the product
 * paints of the Banyan has to be the same picture next time — a canopy that
 * reshuffled on each visit would say the tree had changed — so nothing here
 * reads a clock or Math.random: a scene is seeded by what it is a scene of.
 *
 * fnv1a mirrors life-nodes.js, so a node's id lands on the same number on
 * both sides of the wire.
 */

export function fnv1a(str: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
  return h >>> 0;
}

/**
 * The scenery's generator: a plain LCG, one stream per seed. Held here so the
 * canopy on the homepage and the one on a place page draw from the same one.
 */
export function rng(seed: number): () => number {
  let s = seed >>> 0 || 1;
  return () => { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
}
